var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[(_vm.userTypesList.length)?_vm._l((_vm.userTypesList),function(item){return _c('span',{key:item.type,staticClass:"role-label mt-6 fl mr-2"},[_vm._v(_vm._s(item.name))])}):_c('span',[_vm._v("-")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }